import React from 'react';
import { Link, } from 'react-router';
import PropTypes from 'prop-types'
import $ from 'jquery';
import VMasker from 'vanilla-masker';
import { StickyContainer, Sticky, } from 'react-sticky';
import { history, } from '../../store';
import { ellipses, numbersWithComma, netcoreScript, adminUserIds, disabledCart, prefixNumber, maskCartWarehouseLabel, maskWarehouseById } from '../../utils/utils';
import { debounce } from 'lodash'
import ReactDOM from 'react-dom';
import AdvisoryExtensionModal from '../AdvisoryExtensionModal';
import AdvisoryModal from '../AdvisoryModal';
import RequiredModal from './RequiredModal';

import Tour from './Tour';
import '../../../public/css/media/_cart.scss';
import '../../../public/css/media/_cart-details.scss';
import '../../../public/css/media/_cart-empty.scss';
import CartTutorial from '../Tutorial';

import VASIcon from '../../../public/img/icons/vas.svg';
import { filterWarehouse } from '../../utils/whiteListed';
import { warehouseIDToCode } from '../../utils/warehouseFlags';
import ComputationBreakdown from './ComputationBreakdown';
import DamagedBanner from '../DamagedBanner';
import DamagedModal from '../DamagedModal';
// import AlertAdvisory from '../AlertAdvisory';

const createReactClass = require('create-react-class');
const Dashboard = createReactClass({

  contextTypes: {
    router: PropTypes.object.isRequired,
  },
  getInitialState: function () {

    return {
      style: 'top: 1000px;',
      parcel: {},
      disabled: true,
      chkItemArray: { "sea": [], "air": [], seaDangerous: [], airDangerous: [], },
      chkItemArray2: { "sea": [], "air": [], seaDangerous: [], airDangerous: [], },
      data: [],
      cargo: "",
      insurance: {},
      itemOrigin:{},
      id: "",
      insured_value: "",
      checked_all: false,
      changepassword: false,
      checked: [],
      checked_insured_value: {},
      cancelled: false,
      selectAll: true,
      overpriced: [],
      number: "",
      incompleteInfo: false,
      timeout: null,
      payment_error: false,
      isFetched: false,
      tour: {
        address: false,
        cart: false,
        shipments: false,
        account: false,
        estimate: false,
        track: false,
      },
      phone_number: '',
      isHaywardEmpty: true,
      damagedModalOpen: false,
      minInsuredValue: false,
      cartConsent: false,
    }

  },
  checkIfInsuredValueIsValid (insured_value, max_insured_value){
    if (insured_value < 1) {
      this.props.showInsuredValueLessThanZeroErrorMessage();
      return false;

    }

    if (isNaN(insured_value)) {
      this.props.showInsuredValueNaNErrorMessage();
      return false;
    }

    if (insured_value.length === 0 || parseInt(insured_value,10) > max_insured_value) {
      this.props.showInsuredValueErrorMessage();
      return false;

    }

    return true;
  },
  componentWillMount() {
    this.props.clearCheck();
    this.props.resetOffsizeConsent();
    this.sendInsuredValue = debounce((id,event) => {

        this.props.removeInsuredValueErrorMessage();
        let last_insured_value = event.target.dataset.lastvalue || null;
        var insured_value = event.target.value;
        var { checked, checked_insured_value } = this.state;
        let max_insured_value = JSON.parse(this.props.settings.destinationSettings.data.filter(data => data.name === "general_setting")[0].settings).insurance_max_value.value;
        let warehouse_id = this.props.customerInfo.warehouse.data.find(data => data.id === Number(this.props.cart.shipment_location_details.origin)).id
        var token = localStorage.jwtToken;
        if (this.checkIfInsuredValueIsValid(insured_value,max_insured_value)) {

          if (checked.indexOf(id) === -1) {
            checked.push(id);
          }

          this.setState({ checked: checked });

          if(this.refs["checkbox" + id].checked){
            this.props.updateInsuredValueAndRecalculateShipmentCost(id,event.target.value,token,this.state.chkItemArray,this.state.insurance,this.state.itemOrigin,this.props.cart.shipment_location_details,false);
          }else {
            this.props.updateInsuredValue(token,id,event.target.value, warehouse_id, this.props.cart.shipment_location_details.destination);
          }

        } else {
          // this.refs["insured_value" + id].value = last_insured_value;
          this.setState({
            checked_insured_value: {
            ...checked_insured_value,
            [id]: last_insured_value || ""
            }
          })
        }

        //pertains to checking and unchecking of item ang select all behavior ->fluxion
        var totalCheck = this.state.chkItemArray.air.length + this.state.chkItemArray.sea.length;

        if (this.state.checked.length > 0) {
          if (this.state.checked.length > totalCheck) {
            this.refs.selectAll.checked = false;
          }
          else {
            this.refs.selectAll.checked = true;
          }
          this.setState({ selectAll: false, });

        } else {
          this.refs.selectAll.checked = false;
          this.setState({ selectAll: true, });
        }

        //if (this.refs["insured_value" + id].value === '' || this.refs["insured_value" + id].value <= 0) {
        if(this.state.checked_insured_value[id] === '' || this.state.checked_insured_value[id] <= 0) {
          if (this.refs["checkbox" + id].checked) {
            this.refs["checkbox" + id].click();
          }
        }

        //if current item is checked, must call this.props.getCheck to recalculate

        /*FOR DYNAMIC COMPUTATION BASED ON INSURED VALUE INPUT*/
        // if (this.refs["insured_value" + id].value !== '' && this.refs["insured_value" + id].value > 0 && this.refs["checkbox" + id].checked) {
        //   if (parseInt(this.refs["insured_value" + id].value, 10) > parseInt(this.props.settings.general_settings.data.settings.insurance_max_value.value, 10)) {
        //     let overpriced = this.state.overpriced;
        //     overpriced.push(id);
        //     this.setState({ overpriced: overpriced, })
        //     window.scrollTo(0, 0);
        //     this.props.clearCheck();
        //   } else {
        //     let insured_value = this.state.insurance;
        //     let overpriced = this.state.overpriced;
        //     insured_value[id] = this.refs["insured_value" + id].value;
        //     overpriced.splice(this.state.overpriced.indexOf(id), 1);
        //     this.setState({ insurance: insured_value, overpriced: overpriced, }, () => {

        //       if (this.state.overpriced.length === 0) {
        //         this.props.getCheck(token, this.state.chkItemArray, this.state.insurance,false);
        //       }
        //     });
        //   }
        // }

    }, 1000);

    const token = localStorage.jwtToken;
    const warehouse_id = this.props.settings.gen_set_fetched ? this.props.settings.general_settings.data.warehouse_id : null;
    // this.props.getParcel(token);
    this.props.getCartData((this.props.parcelInfo.cartData && warehouseIDToCode(this.props.parcelInfo.cartData.active_warehouse.id)) || null);
    this.props.getProhibitedParcel(token);
    this.props.getModalBlocks('cartExtension');
    this.props.getModalBlocks('cart');
    this.props.getStorageSettings(warehouse_id);

    if (!this.props.login.fetched) {
      this.props.signedIn(token);
    }

    $('.cart').addClass('active');
    localStorage.ChangePassword ? this.setState({ changepassword: true, }) : this.setState({ changepassword: false, });
    localStorage.removeItem('ChangePassword');

    /*FOR CANCELLED TRANSACTIONS*/
    if (Object.prototype.hasOwnProperty.call(this.props.location, 'query')) {
      if (this.props.location.query.status === "canceled" || this.props.location.query.status === "rejected" || this.props.location.query.status === "expired") {
        var payment_provider = this.props.location.query.payment_provider;
        var ref_id = Object.prototype.hasOwnProperty.call(this.props.location.query, 'Ref') ? this.props.location.query.Ref : this.props.location.query.token;
        var payment_status = this.props.location.query.status;

        if (payment_provider === 'paypal') {
          this.props.setPayment(payment_provider, payment_status, ref_id);
        }
      }
    }     
    
    // if(this.props.customerInfo.warehouse.data){
    //   const id = this.props.customerInfo.warehouse.data.find(data => data.id === this.props.cart.shipment_location_details.origin).id
    //   this.props.getDestinationSettings(id, this.props.cart.shipment_location_details.destination);
    // } 

    if (localStorage.trackPackage2) {
      history.push("/track");
    }
  },
  componentWillReceiveProps(nextProps){
    if (nextProps.login.fetched && nextProps.login.login.party){
      const admin = adminUserIds.find(id => id === nextProps.login.login.party.account_number)
      if(!admin && disabledCart){
        return history.push('/shipment')
      }
    }
    $('#SCTitle').text("Cart | ShippingCart");
    let { checked_insured_value } = this.state;
    if (nextProps.parcelInfo.cartData && !nextProps.parcelInfo.error){
      let { checked } = this.state;

      if(nextProps.parcelInfo.cartData.items.length > 0){
        this.setState({selectAll:false});

        nextProps.parcelInfo.cartData.items.forEach(parcel => {
          if(parcel.insured_value){
            this.setState({ ["chk_" + parcel.id]: parcel.id, });

            if (checked.indexOf(parcel.id) === -1) {
              checked.push(parcel.id);
              checked_insured_value[parcel.id] = parcel.insured_value
            }

            if((Number(nextProps.cart.shipment_location_details.origin) !== parcel.warehouse_id) ||
              (nextProps.cart.shipment_location_details.destination === "MY" && (parcel.flags.allowed_air !== 1 && parcel.flags.allowed_sea === 1))) {
              let index = checked.indexOf(parcel.id);
              if (index > -1){
                checked.splice(index, 1)
              }
            }

            this.setState({ checked: checked, checked_insured_value });
          }
        });
      }
    }

    if (nextProps.parcelInfo.insured_value_error){
      let parcel_id = nextProps.parcelInfo.insured_value_update_error.data.errors.meta.parcel_id;
      let last_insured_value = nextProps.parcelInfo.insured_value_update_error.data.errors.meta.insured_value;
      //this.refs["insured_value" + parcel_id].value = last_insured_value;
      this.setState({
        checked_insured_value: {
        ...checked_insured_value,
        [parcel_id]: last_insured_value || ""
        }
      })

      let overpriced = this.state.overpriced;
      overpriced.splice(this.state.overpriced.indexOf(parcel_id), 1);
      this.setState({ overpriced: overpriced, });

      if (!last_insured_value || isNaN(last_insured_value) || last_insured_value === 0){
        this.setState({ ["chk_" + parcel_id]: '', });
      } else {
        this.setState({ ["chk_" + parcel_id]: parcel_id, });
      }

      if (this.state.chkItemArray.sea.length > 0 || this.state.chkItemArray.air.length > 0) {
        let token = localStorage.jwtToken;
        this.props.getCheck(token, this.state.chkItemArray, this.props.cart.shipment_location_details, this.state.insurance, this.state.itemOrigin,true)
      }

    } else{
      if (nextProps.parcelInfo.updated_parcel){

        let parcel_id = nextProps.parcelInfo.updated_parcel.data.id;
        let insured_value = nextProps.parcelInfo.updated_parcel.data.insured_value;
        checked_insured_value[parcel_id] = insured_value

        if (!this.props.parcelInfo.less_than_zero_error_message){
          this.setState({ ["chk_" + parcel_id]: parcel_id, checked_insured_value });
        }
      }
    }
    if (nextProps.login.login.party){
      if (!nextProps.login.login.party.email || nextProps.login.login.party.email === `${nextProps.login.login.party.fb_id}@gmail.com` || !nextProps.login.login.party.phone_number || !prefixNumber(nextProps.login.login.party.phone_number.slice(0,3))){
        this.setState({incompleteInfo:true})
      }else{
        this.setState({incompleteInfo:false})
      }
      if(nextProps.login.login.party.phone_number){
        this.setState({phone_number: nextProps.login.login.party.phone_number})
      }
      this.setState({accountDetails: nextProps.login.login.party})
    }

    const cartModalContent = nextProps.cms.getModal && nextProps.cms.modalContent && nextProps.cms.modalContent.data.variable === "Cart-Modal" ? nextProps.cms.modalContent.data.status : false;
    this.setState({cartModalContent})
  },
  componentWillUnmount() {

    this.props.clearCheck();
    localStorage.removeItem("trackPackage2");
    this.props.clearCartMessages();
  },
  componentDidMount() {
    window.scrollTo(0, 0);
 
    VMasker(document.getElementsByClassName("insured-input")).maskNumber();
    VMasker(document.querySelectorAll(".insured_input")).maskNumber();

    // <!-- NetCore Script -->
    const accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '' ;
    window.smartech && netcoreScript(accountNumber);
    // <!-- NetCore Script -->    
    if (this.props.parcelInfo.getCartData) {
      const defaultWarehouseId = this.props.parcelInfo.cartData.active_warehouse.id;
      if (this.props.parcelInfo.cartData.hayward_item_count) {
        this.setState({isHaywardEmpty: false});
      }
      this.props.updateShipmentLocations(defaultWarehouseId, "origin", this.props.cart.shipment_location_details);
      this.props.getDestinationSettings(defaultWarehouseId, this.props.cart.shipment_location_details.destination);
    }
  },
  componentDidUpdate(prevProps, prevState) {
    if (this.props.login.error) {
      if (this.props.login.status === 401) {
        history.push("/signin");
      }
    }
    if(prevState.phone_number !== this.state.phone_number && prevProps.parcelInfo.getCartData !== this.props.parcelInfo.getCartData){
      // const defaultWarehouseId = this.props.parcelInfo.cartData.active_warehouse.id;
      // if(this.state.phone_number.includes("+60") && defaultWarehouseId !== 4 && defaultWarehouseId !== 5){
      //   this.props.updateShipmentLocations("MY", "destination", this.props.cart.shipment_location_details)
      // }
      if(this.state.phone_number.includes("+63")){
        this.props.updateShipmentLocations("PH", "destination", this.props.cart.shipment_location_details)
      }
    }
    if (prevProps.parcelInfo.getCartData !== this.props.parcelInfo.getCartData) {
      const defaultWarehouseId = this.props.parcelInfo.cartData.active_warehouse.id;
      if (this.props.parcelInfo.cartData.hayward_item_count) {
        this.setState({isHaywardEmpty: false});
      }
      this.props.updateShipmentLocations(defaultWarehouseId, "origin", this.props.cart.shipment_location_details);
      this.props.getDestinationSettings(defaultWarehouseId, this.props.cart.shipment_location_details.destination);
    }
  },
  clearTimeout(val){
    setTimeout()
  },
  handleInputInsuredValue(id,event){
    const { checked_insured_value } = this.state

    this.setState({
      checked_insured_value: {
        ...checked_insured_value,
        [id]: event.target.value.toString().split(".").map((el,i)=>i?el.split("").slice(0,2).join(""):el).join(".")
      }
    })

    event.persist();
    this.sendInsuredValue(id,event);
  },
  handleCheck(id, event) { //handler for checkbox enabling

    var last_value = event.currentTarget.dataset.lastvalue;
    var number = parseInt(event.target.value, 10) || 0;
    var num = event.target.value;
    var checked = this.state.checked;

    if (num.length === 0) {
      this.refs["insured_value" + id].value = "";
      this.setState({ ["chk_" + id]: "", });
    }

    if (num.length === 1) {
      if (!isNaN(num) && num !== 0) { //if the value is a number and it is not = 0
        this.setState({ number: num, });
        this.setState({ ["chk_" + id]: id, });

      } else {
        this.refs["insured_value" + id].value = last_value; // if not a number, remove character in textbox
        this.setState({ ["chk_" + id]: "", });

      }
    } else {
      if (!isNaN(num)) {
        this.setState({ number: num, });
        this.setState({ ["chk_" + id]: id, });

      } else {
        this.refs["insured_value" + id].value = last_value; //revert the value in the textbox to the previous number without non-numeric characters.
      }
    }
    if (number <= 0) {
      this.setState({["chk_" + id]: "",});    //this.state.chk_id = null if insured value is null

      if (checked.indexOf(id) !== -1) {
        checked.splice(checked.indexOf(id), 1);
      }

      this.setState({ checked: checked, });
    } else {
      this.setState({
        ["chk_" + id]: id,  //this.state.chk_id = id if insured value is NOT null
      });
      if (checked.indexOf(id) === -1) {
        checked.push(id);
      }
      this.setState({ checked: checked, });
    }
    var totalCheck = this.state.chkItemArray.air.length + this.state.chkItemArray.sea.length;
    if (this.state.checked.length > 0) {
      if (this.state.checked.length > totalCheck) {
        this.refs.selectAll.checked = false;
      }
      else {
        this.refs.selectAll.checked = true;
      }
      this.setState({ selectAll: false, });
    }
    else {
      this.refs.selectAll.checked = false;
      this.setState({ selectAll: true, });
    }
  },
  handleCheckout() { //Triggered when SHIP IT button is clicked.
    const token = localStorage.jwtToken;

    let chkItemArray = {
      air: this.props.customerCheckout.checkout.data.hasOwnProperty("air") ? [...this.props.customerCheckout.checkout.data.air.parcels] : [],
      sea: this.props.customerCheckout.checkout.data.hasOwnProperty("sea") ? [...this.props.customerCheckout.checkout.data.sea.parcels] : []
    };

    let sc_protect = { avail: 1 };
    this.props.checkOut(token, chkItemArray, this.state.insurance, this.props.cart.shipment_location_details, this.state.itemOrigin, sc_protect, this.state.chkItemArray);
  },
  checkAll() {
    this.state.checked_all ? this.setState({ checked_all: false, }) : this.setState({ checked_all: true, })
  },
  handleMethod(id) { //handler for shipping method change
    var chkArray = this.state.chkItemArray;
    const token = localStorage.jwtToken;

    if (chkArray.air.indexOf(id) !== -1) {
      chkArray.sea.push(id)
      chkArray.seaDangerous.push(id);
      chkArray.air.splice(this.state.chkItemArray.air.indexOf(id), 1);
      chkArray.airDangerous.splice(this.state.chkItemArray.airDangerous.indexOf(id), 1);
      this.setState({ chkItemArray: chkArray, });
    }
    else if (chkArray.sea.indexOf(id) !== -1) {
      chkArray.air.push(id);
      chkArray.airDangerous.push(id);
      chkArray.sea.splice(this.state.chkItemArray.sea.indexOf(id), 1);
      chkArray.seaDangerous.splice(this.state.chkItemArray.seaDangerous.indexOf(id), 1);
      this.setState({ chkItemArray: chkArray, });
    }
    if (this.state.overpriced.length === 0 && (this.state.chkItemArray.air.length > 0 || this.state.chkItemArray.sea.length > 0) && this.state.itemOrigin.hasOwnProperty(id)) {
      this.props.getCheck(token, this.state.chkItemArray, this.props.cart.shipment_location_details, this.state.insurance, this.state.itemOrigin, true);
    }
  },

  handleClick(id, warehouse_id, flags, event) { //handler for checked/unchecked box
    this.props.clearCartMessages();
    this.props.removeInsuredValueErrorMessage();
    const token = localStorage.jwtToken;
    let max_insured_value = JSON.parse(this.props.settings.destinationSettings.data.filter(data => data.name === "general_setting")[0].settings).insurance_max_value.value;
    
    if (event.target.checked) { //if box is checked
      this.setState({
        id: id,
        insured_value: this.state.checked_insured_value[id],
        itemOrigin: warehouse_id,
      },
        () => {
          if (parseInt(this.state.insured_value, 10) > parseInt(max_insured_value, 10)) {
            let overpriced = this.state.overpriced;
            overpriced.push(id);
            this.setState({ overpriced: overpriced, });
            window.scrollTo(0, 0);
          }
          else {
            let overpriced = this.state.overpriced;
            overpriced.splice(this.state.overpriced.indexOf(id), 1);
            this.setState({ overpriced: overpriced, });
          }
        });
      var parcel_value = this.state.checked_insured_value[id];
      var parcel_insurance = this.state.insurance;
      var parcel_wid = warehouse_id;
      var parcel_origin = this.state.itemOrigin;
      parcel_insurance[id] = parcel_value;
      parcel_origin[id] = parcel_wid;
      this.setState({ insurance: parcel_insurance, itemOrigin: parcel_origin });
      var chkArr = this.state.chkItemArray;

      if (this.refs["shipment_method" + id].value === 'sea' || this.refs["shipment_method" + id].value === "Sea cargo only") {
        chkArr.sea.push(id); //PUSH TO SEA THE ID OF PARCEL
        if (flags.dangerous === 1) {
          chkArr.seaDangerous.push(id)
        }
      } else {
        chkArr.air.push(id);//PUSH TO AIR THE ID OF PARCEL
        if (flags.dangerous === 1) {
          chkArr.airDangerous.push(id)
        }
      }
      this.setState({ chkItemArray: chkArr });
      if (this.state.overpriced.length === 0) {
        this.props.getCheck(token, this.state.chkItemArray, this.props.cart.shipment_location_details, this.state.insurance, this.state.itemOrigin,true);
      }
    }

    else { //if box is UNCHECKED
      this.setState({
        insured_value: "",
      });

      let overpriced = this.state.overpriced;
      overpriced.splice(this.state.overpriced.indexOf(id), 1);
      this.setState({ overpriced: overpriced, });

      var insurance = {};
      var origin = {}
      insurance = this.state.insurance;
      origin = this.state.itemOrigin;
      chkArr = this.state.chkItemArray;
      if (this.refs["shipment_method" + id].value === 'sea' || this.refs["shipment_method" + id].value === "Sea cargo only") {
        chkArr.sea.splice(this.state.chkItemArray.sea.indexOf(id), 1); //remove from SEA array
        chkArr.seaDangerous.splice(this.state.chkItemArray.seaDangerous.indexOf(id), 1); //remove from SEA array
        delete insurance[id];
        delete origin[id];
      } else {
        chkArr.air.splice(this.state.chkItemArray.air.indexOf(id), 1); //remove from AIR array
        chkArr.airDangerous.splice(this.state.chkItemArray.airDangerous.indexOf(id), 1); //remove from SEA array
        delete insurance[id];
        delete origin[id];
      }
      this.setState({
        chkItemArray: chkArr,
      }, () => {
        if (this.state.chkItemArray.sea.length > 0 || this.state.chkItemArray.air.length > 0) {
          this.props.getCheck(token, this.state.chkItemArray, this.props.cart.shipment_location_details, this.state.insurance, this.state.itemOrigin,true)
        }
        else {
          this.setState({ id: "", cartConsent: false });
          this.props.clearCheck();
        }
      });
    }
    var totalCheck = this.state.chkItemArray.air.length + this.state.chkItemArray.sea.length;
    if (this.state.checked.length > 0) {
      if (this.state.checked.length === totalCheck) {
        this.refs.selectAll.checked = true;
        this.setState({ selectAll: false, });
      } else {
        this.refs.selectAll.checked = false;
      }
    } else {
      this.refs.selectAll.checked = false;
      this.setState({ selectAll: true, });
    }
  },
  handleCheckAll(warehouse_id, parcels, e) {
    this.setState({chkItemArray:{ "sea": [], "air": [], seaDangerous: [], airDangerous: [], }});
    this.setState({chkItemArray2:{ "sea": [], "air": [], seaDangerous: [], airDangerous: [], }});

    const dangerous = parcels.filter(parcel => parcel.insured_value).map(parcel => parcel.flags.dangerous);
    
    var i = 0;
    var checked = this.state.checked;
    var chkItemArray2 = this.state.chkItemArray2;
    var insurance = {};
    var origin = {};
    const token = localStorage.jwtToken;

    for (i = 0; i < checked.length; i++) {
      if (this.refs["checkbox" + checked[i]] && !this.refs["checkbox" + checked[i]].disabled) {
        this.refs["checkbox" + checked[i]].checked = e.target.checked;
      if (this.refs["checkbox" + checked[i]] && this.refs["checkbox" + checked[i]].checked) {
        this.setState({ id: "id", });
        if (this.refs["shipment_method" + checked[i]].value === "sea" || this.refs["shipment_method" + checked[i]].value === "Sea cargo only") {
          chkItemArray2.sea.push(checked[i]);
          insurance[checked[i]] = this.state.checked_insured_value[checked[i]];
          origin[checked[i]] =  warehouse_id[i];

          if (dangerous[i]  === 1) {
            chkItemArray2.seaDangerous.push(checked[i]);
          }
        }
        else {
          chkItemArray2.air.push(checked[i]);
          insurance[checked[i]] = this.state.checked_insured_value[checked[i]];
          origin[checked[i]] = warehouse_id[i];

          if (dangerous[i] === 1) {
            chkItemArray2.airDangerous.push(checked[i]);
          }
        }
        this.setState({ itemOrigin: origin, insurance: insurance, chkItemArray: chkItemArray2 });
      }
      else {
        if (this.refs["shipment_method" + checked[i]].value === "sea" || this.refs["shipment_method" + checked[i]].value === "Sea cargo only") {
          chkItemArray2.sea.splice(chkItemArray2.sea.indexOf(checked[i]), 1);
          chkItemArray2.seaDangerous.splice(chkItemArray2.sea.indexOf(checked[i]), 1);
          delete insurance[checked[i]];
          delete origin[checked[i]];
        }
        else {
          chkItemArray2.air.splice(chkItemArray2.air.indexOf(checked[i]), 1);
          chkItemArray2.airDangerous.splice(chkItemArray2.air.indexOf(checked[i]), 1);
          delete insurance[checked[i]];
          delete origin[checked[i]];
        }
        this.setState({ itemOrigin: origin, insurance: insurance, chkItemArray: chkItemArray2 });
      }

    }
    }
    if (
      this.state.chkItemArray2.air.length ||
      this.state.chkItemArray2.sea.length
    ) {
      this.props.getCheck(
        token,
        this.state.chkItemArray2,
        this.props.cart.shipment_location_details,
        insurance,
        origin,
        true,
      );
    } else {
      this.setState({ cartConsent: false });
      this.props.clearCheck();
    }
  },
  handleForm(e) {
    e.preventDefault();
  },
  handleDate(date) {
    if (date) {
      var sliced_date = date.slice(0, 10);
      var split_date = sliced_date.split("-");
      var new_date = split_date[1] + "/" + split_date[2] + "/" + split_date[0].substring(2, 4)
      return new_date;
    }
    else { return null; }
  },
  handleInsuredHover(id) {
    ReactDOM.findDOMNode(this.refs["insured_value" + id]).focus();
  },
  handleRemoveInsuredHover(id) {
    ReactDOM.findDOMNode(this.refs["insured_value" + id]).blur();
  },
  setUSHaywardasActiveOrigin() {
    const destination = this.props.cart.shipment_location_details.destination
    this.props.updateShipmentLocations(1, "origin", this.props.cart.shipment_location_details)
    this.props.getStorageSettings(1);
    this.props.getDestinationSettings(1, destination)
    this.state.checked.map(check => this.refs["checkbox" + check].checked = false)
    this.refs.selectAll.checked = false;
    this.props.clearCheck();

    this.setState({
      chkItemArray:{
        "sea": [],
        "air": [],
        seaDangerous: [],
        airDangerous: []
      },
      insurance: {},
      id: "",
      itemOrigin: {}
    })
  },
  handleShipmentLocations(e, type) {
    let origin = Number(e.target.value)
    let destination;
    if (origin === 4 || origin === 5){
      this.props.cart.shipment_location_details.destination = "PH";
    }
    this.props.updateShipmentLocations(e.target.value, type, this.props.cart.shipment_location_details)
    if(type === "origin"){
      // warehouse_id = this.props.customerInfo.warehouse.data.find(data => data.id === e.target.value).id
      destination = this.props.cart.shipment_location_details.destination
      this.props.getStorageSettings(origin);
      this.props.getCartData(warehouseIDToCode(origin))
      this.props.clearCheck();
      this.setState({
        chkItemArray:{
          "sea": [],
          "air": [],
          seaDangerous: [],
          airDangerous: []
        },
      });
    }
    if(type === "destination"){
      origin = Number(this.props.cart.shipment_location_details.origin)
      destination = e.target.value
      
      this.props.getCartData(warehouseIDToCode(origin))
      this.props.clearCheck();
      this.setState({
        chkItemArray:{
          "sea": [],
          "air": [],
          seaDangerous: [],
          airDangerous: []
        },
      });
    }
    this.props.getDestinationSettings(origin, destination)
    this.refs.selectAll.checked = false;
    this.props.clearCheck();

    this.setState({
      chkItemArray:{
        "sea": [],
        "air": [],
        seaDangerous: [],
        airDangerous: []
      },
      chkItemArray2:{
        "sea": [],
        "air": [],
        seaDangerous: [],
        airDangerous: []
      },
      insurance: {},
      id: "",
      itemOrigin: {},
      checked: [],
      cartConsent: false,
    })
  },
  cartModal() {
    return { __html: this.props.cms.getModal ? this.props.cms.modalContent.data.content.body : null, };
  },
  cartExtensionModal() {
    return { __html: this.props.cms.getModal ? this.props.cms.modalExtensionContent.data.content.body : null, };
  },
  render() {
    // const days = this.props.settings.stor_set_fetched ? this.props.settings.storage_settings.data.settings.days_free_of_charge.value - this.props.settings.storage_settings.data.settings.item_free_charge_threshold.value : null;
    // const free_change = this.props.settings.stor_set_fetched ? this.props.settings.storage_settings.data.settings.days_free_of_charge.value : null;
    let parcel_details = this.props.parcelInfo.cartData ? this.props.parcelInfo.cartData.items : [];
    let origin = Number(this.props.cart.shipment_location_details.origin);
    const customerType = this.props.login && this.props.login.login.party && JSON.parse(this.props.login.login.party.party.metadata).customer_type
    // COVID 19 RESPONSE
    const inboundBanner = this.props.settings.destinationSettings && JSON.parse(this.props.settings.destinationSettings.data.filter(data => data.name === 'inbound_banner')[0].settings);

    const minChargableWeight =
      this.props.settings.destinationSettings &&
      JSON.parse(
        this.props.settings.destinationSettings.data.filter(
          (data) => data.name === "minimum_chargeable_weight"
        )[0].settings
      );

    // if (this.props.parcelInfo.cartData){
    //     // parcel_details = this.props.parcelInfo.cartData.items.filter(parcel =>
    //     //   (parcel.warehouse_id === origin)
    //     // )
    //     if (this.props.cart.shipment_location_details.destination === "MY") {
    //       parcel_details = this.props.parcelInfo.cartData.items.filter(parcel =>
    //       (parcel.warehouse_id === origin && parcel.flags.allowed_air === 1 && parcel.flags.allowed_sea !== 1) || 
    //       (parcel.warehouse_id === origin && parcel.flags.allowed_air === 1 && parcel.flags.allowed_sea === 1)
    //       )
    //     }
    // }

    return (
      <div>
        {this.state.accountDetails && this.props.parcelInfo.cartData && this.props.parcelInfo.cartData.items.length > 0 &&
          <CartTutorial type="cart_tutorial" accountDetails={this.state.accountDetails}/>
        }
        <div className={this.state.changepassword ? "sc-alert signup" : "disnone"} ><i className="sc"></i>You can now use your new password to access your ShippingCart account!</div>

        {
          this.props.cart.cancelled_payment ?
              (this.props.customerCheckout.error && this.props.customerCheckout.error.response.data.errors.detail === "Cannot update payment is already paid.") ? null
              : <div className="sc-alert  cart-sc"><i className="sc"></i>Your transaction is cancelled.</div>
            : null
        }

        { this.props.cart.show_empty_checkout_items ? <div className="sc-alert  signup"><i className="sc"></i>You have no items to check out. Please select an item again and proceed to payment.</div> : null }

        {
          this.props.cart.payment_error ?
            (this.props.cart.cancelled_payment) || (this.props.customerCheckout.error && 
            this.props.customerCheckout.error.response.data.errors.detail === "Cannot update payment is already paid.") 
            ? <div className="sc-alert  cart-sc2"><i className="sc"></i>Your payment is being processed. You will receive an email notification once your payment has been confirmed.</div>
            : <div className="sc-alert sc-alert-danger2" ><i className="sc"></i>Unable to process payment.</div>
          : null
        }

        {
          this.props.cart.invalid_transaction ?
            <div className="sc-alert sc-alert-danger2"><i className="sc"></i>We were unable to process your ShippingCart payment. Wait for a few minutes, then check if your item/s are back in your Cart before attempting to check out again.</div>
          : null
        }

        {!disabledCart && <Tour />}
        <div className="main-content storage-content">
          {!this.props.parcelInfo.getCartData ? null : this.props.parcelInfo.cartData && this.props.parcelInfo.cartData.items.length >=0 ?

            <div className="storage-wrapper">
              <div className="cart-header">
                <h4>Hi {this.props.login.fetched ? this.props.login.login.party.first_name : null}, shipping something today?</h4>
                <div className="shipment-destination">
                  <span>FROM</span>
                  <div className="source select-gradient">
                    <select className="selected-method" value={origin} onChange={ (e) => this.handleShipmentLocations(e, "origin")} disabled={this.props.parcelInfo.parcel_updating}>
                      {this.props.customerInfo.warehouse.data && filterWarehouse(this.props.customerInfo.warehouse.data, this.props.login.login.party).map((warehouse) => (<option value={warehouse.id}>{maskCartWarehouseLabel(warehouse, filterWarehouse(this.props.customerInfo.warehouse.data, this.props.login.login.party).find(item => item.id === 6))}</option>))}
                    </select>
                  </div>
                  <span>TO</span>
                  <div className="destination select-gradient">
                    <select className="selected-method" value={this.props.cart.shipment_location_details.destination} onChange={ (e) => this.handleShipmentLocations(e, "destination")}>
                      <option value="PH">Philippines</option>
                      {/* {origin !== 4 && origin !== 5 && <option value="MY">Malaysia</option>} */}
                    </select>
                  </div>
                </div>
              </div>

              { (this.props.cart.shipment_location_details.destination === "MY") &&
                <div style={{ "fontSize": "12px", "fontStyle": "italic" }}>*Please note that only AIR cargo is available for shipments from {maskWarehouseById(origin)} to {this.props.cart.shipment_location_details.destination}.</div>
              } 

              { //dynamic banner
                inboundBanner.status && inboundBanner.status.value === 1 && 
                <div className="sc-warning" style={{display: 'flex', alignItems: 'center'}}>
                  <i
                    className="fa fa-exclamation-circle"
                    style={{ marginRight: '10px', color: '#feab10', fontSize: 17 }}
                  />
                    {inboundBanner.message.value}
                    <a href={`/${inboundBanner.redirection_link.value}`} target="_blank" ><i className="fa fa-angle-right fa-lg icon-angle-right" aria-hidden="true"/> </a>
                </div>
              }

              <div className={this.props.parcelInfo.display_error_message || this.state.overpriced.length > 0 ? '' : 'disnone'}>
                <div ref="errors_credentials" className="sc-alert sc-alert-danger"><i className="sc"></i>The value of this item needs verification. Visit our Contact Us page for assistance.</div>
              </div>

              <div className={this.props.parcelInfo.less_than_zero_error_message ? '' : 'disnone'} style={{marginTop: '5px'}}>
                <div ref="errors_credentials" className="sc-alert sc-alert-danger"><i className="sc"></i>You cannot declare an insured value below 1USD.</div>
              </div>

              <div className={this.props.parcelInfo.insured_value_nan_error_message ? '' : 'disnone'}>
                <div ref="errors_credentials" className="sc-alert sc-alert-danger"><i className="sc"></i>Insured value must be numbers only</div>
              </div>

              <div className="partial messages clearfix">
              </div>
              {this.props.parcelInfo.cart_fetching ? null : !this.props.parcelInfo.cart_fetching && parcel_details ?
                <StickyContainer >
                  <div className="clearfix">

                    <form className="pull-left cartable" id="ship-it" onSubmit={this.handleForm}>

                      <table className="item-list" id="stored-items">
                        <thead style={{backgroundColor: '#F1F1F1'}}>
                          <tr>
                            <th>Select Item/s</th>
                            <th>
                              <span>Insured value</span>
                              <div className="fa fa-question-circle fa-fw">
                                <div className="tooltip white package-value-tooltip" style={{width: 300, textAlign: 'left'}}>
                                  <p style={{fontSize: '10px', margin: '3px 0px'}}>Declare the value of your items correctly to keep them secure.</p>
                                  <p style={{fontSize: '10px', margin: '3px 0px'}}>This helps us make sure you’re fairly reimbursed, in case anything happens, such as damage during shipping or if something goes missing.</p>
                                  <p style={{fontSize: '10px', margin: '3px 0px'}}>Remember, our insurance covers up to $20,000 per shipment, with a limit of $10,000 for each item.</p>
                                  <a href="https://help-center.shippingcart.com/hc/en-us/articles/4907826208143-What-is-declared-value-and-why-is-it-important-" style={{fontSize: '10px', fontWeight: 600}} target="_blank" rel="noopener noreferrer">
                                    Importance of declaring proper insured value
                                  </a>
                                </div>
                              </div>
                            </th>
                            <th>
                              <span>Shipping method</span>
                              <div className="fa fa-question-circle fa-fw">
                                <div className="tooltip white">
                                  <p>Select your desired shipping mode. It takes 10 days via Air Cargo and 45 days via Sea Cargo.
                                        </p>
                                </div>
                              </div>
                            </th>

                            <th>Details</th>
                          </tr>
                        </thead>
                        <tbody>
                          {parcel_details.filter(parcel => parcel.warehouse_id === this.props.cart.shipment_location_details.origin).map((parcel) => <tr id={parcel.id} key={parcel.id}>

                            <td className={this.state["chk_" + parcel.id] === parcel.id ? "item-name" : "item-name no-insurance"}>

                              {(parcel.flags.vas_type !== 'PULL_OUT' || parcel.flags.vas_status !== 'COMPLETED') && <div className="checkbox"
                                onMouseEnter={this.state["chk_" + parcel.id] === parcel.id ? null : this.handleInsuredHover.bind(this, parcel.id)}
                                onMouseLeave={this.state["chk_" + parcel.id] === parcel.id ? null : this.handleRemoveInsuredHover.bind(this, parcel.id)}>
                                <div className={this.state["chk_" + parcel.id] === parcel.id ? "disnone" : "tooltip white black"}>
                                  <p>Please declare the insured value (in USD) of this package to properly valuate your goods.</p>
                                </div>
                                {/* Disable sea cargos when selected destinations is PH due to COVID-19 */}
                                <input
                                  id={["lbl" + parcel.id,]}
                                  data-id={parcel.id}
                                  ref={["checkbox" + parcel.id,]}
                                  onClick={this.handleClick.bind(this, parcel.id, parcel.warehouse_id, parcel.flags)}
                                  data-select="single"
                                  data-item="154990"
                                  data-do="item-select"
                                  data-on="change"
                                  type="checkbox"
                                  className="item-select"
                                  disabled={(!parcel.insured_value) || (parcel.flags.vas_request) || (parcel.flags.vas_type === 'PULL_OUT' && parcel.flags.vas_status === 'COMPLETED') ? "disabled" : ""}
                                />
                                <label id={["lbl" + parcel.id,]} htmlFor={["lbl" + parcel.id,]}></label>
                                <div className={this.state["chk_" + parcel.id] === parcel.id ? "disnone" : "tooltip insured-tooltip white"}>
                                  <p>
                                    Please declare the insured value (in USD) of this package to properly valuate your goods.
                                  </p>
                                </div>
                              </div>}
                              <div className="item-info">
                                <p className="name">
                                  <Link to={"/parcel/" + parcel.id}>{ellipses(customerType === 'social seller' ? parcel.description : parcel.tracking_number, 120)}</Link>
                                </p>
                                <p className="date">
                                  <span className="cart-weight" style={{display:'none'}}>{parcel.dimensions.weight.weight} {parcel.dimensions.weight.uom}</span>
                                  <p className={(parseInt(parcel.storage.storage_days, 10) >= parseInt(parcel.storage.storage_max_days - parcel.storage.max_day_threshold, 10)) && !parcel.flags.free_storage ? "aging-red" : ""}>{parcel.storage.storage_days > 1 ? parcel.storage.storage_days+" days" : parcel.storage.storage_days+" day" } in storage</p>
                                    <div className={parseInt(parcel.storage.storage_days, 10) >= parseInt(parcel.storage.storage_max_days - parcel.storage.max_day_threshold, 10) ? "tooltip aging-date white" : "disnone"}>
                                      <p>
                                        {parseInt(parcel.storage.storage_days, 10) < parseInt(parcel.storage.storage_max_days, 10) ? `Your item is nearing its ${parcel.storage.storage_max_days}-day storage limit. Ship out now!` 
                                        : `This is your last day to ship this item. Ship out now!`}
                                      </p>
                                    </div>
                                </p>
                              </div>
                              <div className="item-icon" style={{textAlign: 'center'}}>
                              {parcel.flags.vas_status === 'PENDING' || parcel.flags.vas_status === 'VAS_APPROVED' || parcel.flags.vas_status === 'PAID' ?
                                  <div className="fa special-handling-icon fa-fw">
                                    <img src={VASIcon} alt="VAS icon" />
                                    <div className="tooltip special-handling-tooltip white">
                                      <p>This item has an active request.</p>
                                    </div>
                                  </div>
                                  :
                                  null
                                }
                                {parcel.flags.special_handling === 1 ?
                                  <div className="fa special-handling-icon fa-fw" style={{height: '24px', width: '24px', backgroundSize: '17px', marginTop: '4px'}}>
                                    <div className="tooltip special-handling-tooltip white icon-tooltip-special-handling" style={{display: 'inline-flex', width: '260px', alignItems: 'center', left: '-132px'}}>
                                      <p style={{margin: '0px'}}>This package requires special handling. </p>
                                      <a href="/special-handling" target="_blank" ><i className="icon-arrow-blue fa fa-angle-right icon-angle-right" aria-hidden="true" /> </a>
                                    </div>
                                  </div>
                                  :
                                  null
                                }
                                {parcel.flags.is_abandoned === 1 ?
                                    <div className="fa icon-hope fa-fw">
                                      <div className="tooltip special-handling-tooltip white" style={{top: '-70px'}}>
                                        <p>This is a Project Hope item.</p>
                                      </div>
                                    </div> : null
                                }
                                {parcel.is_damaged ?
                                  <div className="fa icon-damaged fa-fw" style={{height: '14px', top: '-1px'}}>
                                    <div className="tooltip special-handling-tooltip white" style={{top: '-109px', height: 'auto'}}>
                                      <p>This package contains <b>damaged items</b> which are excluded from SC Protect when you checkout.</p>
                                    </div>
                                  </div> : null
                                }
                              </div>
                            </td>
                            <td className="insured">
                              USD &nbsp;
                              <input type="text" name="insured_value"
                                id={parcel.id}
                                className="insured-input"
                                min="0"
                                ref={["insured_value" + parcel.id,]}
                                //defaultValue={parcel.insured_value}
                                value={this.state.checked_insured_value[parcel.id] || ""}
                                data-lastvalue={parcel.insured_value}
                                onChange={this.handleInputInsuredValue.bind(this, parcel.id)}
                                maxLength="7"
                              />&nbsp;
                                    </td>
                            {/* Disable sea cargos when selected destinations is PH due to COVID-19 */}
                            <td className="shipping-method">
                              {parcel.flags.allowed_air === 1 && parcel.flags.allowed_sea === 1 ?
                                (this.props.cart.shipment_location_details.destination === "MY")
                                ? <button type="button" className="btn btn-disable" name="button" value="Air cargo only" ref={["shipment_method" + parcel.id,]}>Air cargo only</button>
                                : <div className="select-gradient">
                                  <select data-id="154990" name="method[154990]" onChange={this.handleMethod.bind(this, parcel.id, parcel.warehouse_id)} className="shipping-method selected-method" data-do="item-select" data-on="change" ref={["shipment_method" + parcel.id,]}>
                                    <option value="air"  >Air Cargo</option>
                                    <option value="sea"  >Sea Cargo</option>
                                  </select>
                                </div>
                                :
                                null
                              }
                              {(parcel.flags.allowed_air === 1 && parcel.flags.allowed_sea !== 1) ?
                                <button type="button" className="btn btn-disable" name="button" value="Air cargo only" ref={["shipment_method" + parcel.id,]}>Air cargo only</button>
                                :
                                null
                              }
                              {(parcel.flags.allowed_air !== 1 && parcel.flags.allowed_sea === 1) ?
                                <button type="button" className="btn btn-disable" name="button" value="Sea cargo only" ref={["shipment_method" + parcel.id,]}>Sea cargo only</button>
                                :
                                null
                              }
                            </td>
                            <td><Link to={"/parcel/" + parcel.id}>View</Link></td></tr>)
                          }
                        </tbody>
                      </table>
                      <div className="list-actions clearfix">
                        <div className="select-all checkbox">
                          <input
                            id="select-all"
                            type="checkbox"
                            className="item-select"
                            data-select="all"
                            data-do="item-select"
                            data-on="change"
                            onClick={this.handleCheckAll.bind(this, parcel_details.map(parcel => parcel.warehouse_id), parcel_details)}
                            ref="selectAll"
                            disabled={this.state.selectAll || this.state.checked.length === 0}
                          />
                          <label htmlFor="select-all">
                            Select All &nbsp; | &nbsp;<span id="selected-count">{Object.keys(this.state.itemOrigin).length}</span> out of
                                  <span id="total-count"> {parcel_details.filter(parcel => parcel.warehouse_id === this.props.cart.shipment_location_details.origin).length}</span> items selected
                                  </label>
                        </div>
                      </div>
                      <input type="hidden" name="csrf" value="5ac6a0d3ea10c942d3e7d1c067cc54c5" />
                      <input type="hidden" name="customer_id" value="10614" />
                    </form>
                    <div className="estimations-wrapper pull-right">
                      <Sticky className="sticky">
                        {
                          ({
                                      style,
                            isSticky,
                                    }) => {
                            return (



                              <header style={style}>

                                <form id="ship-it">
                                  <div className="arrow_right"></div>

                                  <div className="estimation-actions">
                                    <div className="header">
                                      <i className={this.state.id ? "fa fa-tags faa-shake animated fa-fw" : "fa fa-tags fa-fw"}></i>
                                      <i className="message">Shipment Cost</i>
                                    </div>

                                    
                                    {
                                    this.props.customerCheckout.fetched && this.state.id && Object.keys(this.state.itemOrigin).length > 0 ?
                                      // this.props.customerCheckout.fetchItemComputation ? <i className="fa fa-spinner fa-spin" /> :

                                      // this.props.cart.shipment_location_details.destination !== 'MY'  ? 
                                      this.props.customerCheckout.fetched && this.props.customerCheckout.checkout.data && <div style={{border: '1px solid #E2E2E2', width: '100%', borderRadius: '10px', backgroundColor: '#FFF'}}>
                                      {this.props.customerCheckout.checkout.data.hasOwnProperty("air") && <ComputationBreakdown type='air' data={this.props.customerCheckout.checkout.data} />}
                                      {this.props.customerCheckout.checkout.data.hasOwnProperty("sea") && <ComputationBreakdown type='sea' data={this.props.customerCheckout.checkout.data} minChargableWeight={minChargableWeight} />}
  
                                      <div style={{borderTop: '1px solid #E2E2E2', width: '100%', padding: '20px 16px'}}>
                                        <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: 600, color: '#323232', borderBottom: '1px solid #F1F1F1', marginBottom: '10px', paddingBottom: '10px'}}>
                                          <span>Storage Fee</span>
                                          <span>
                                            {`USD ${numbersWithComma(Number(this.props.customerCheckout.checkout.data.summary.total_storage_charge).toFixed(2)) || '0.00'}`}
                                          </span>
                                        </div>
                                        <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '13px', fontWeight: 600, color: '#323232'}}>
                                          <span style={{ marginRight: 7, alignSelf: 'center' }}>
                                            <img
                                              src="https://cdn.shippingcart.com/assets/sc-protect-logo-final-20231123025932.svg"
                                              alt="sc-protect"
                                              height={18}
                                              width={18}
                                            />
                                          </span>
                                          <span style={{fontStyle: 'italic', fontWeight: 400}}>
                                            SC Protect fee will be computed in the next step.
                                          </span>
                                        </div>
                                        {!!this.props.customerCheckout.checkout.data.damage_items.total && <DamagedBanner
                                          message={
                                            <div>
                                              <span style={{ fontWeight: 600 }}>
                                                {this.props.customerCheckout.checkout.data.damage_items.total} out of{' '}
                                                {this.props.customerCheckout.checkout.data.summary.total_qty} packages
                                              </span>{' '}
                                              contains{' '}
                                              <span
                                                style={{ color: '#0375D9', fontWeight: 600, cursor: 'pointer' }}
                                                onClick={() => this.setState({ damagedModalOpen: true })}
                                              >
                                                damaged item
                                              </span>{' '}
                                              which are excluded from SC Protect when you checkout.
                                            </div>
                                          }
                                          bgColor="#FFE9EB"
                                        />}
                                      </div>
                                    </div>
                                      :
                                      <div className="no-estimations">
                                        <span>Input how much it’s worth, select your preferred item/s, and choose the shipping method to get your shipment cost.</span>
                                      </div>

                                    }







                                  </div>

                                </form>
                                <div className="ship-it-btn wrapper">
                                  <div className="form-actions">
                                    {this.props.customerCheckout.checkout.data && this.props.customerCheckout.checkout.data.summary.total_price &&
                                      <div style={{borderRadius: '10px', border: '1px solid #E2E2E2', backgroundColor: '#FFF', padding: '20px 16px', textAlign: 'left', marginBottom: '10px'}}>
                                        <div style={{fontSize: '16px', fontWeight: 600, marginBottom: '16px'}}>By proceeding,</div>
                                        <div style={{display: 'inline-flex'}}>
                                          <div style={{padding: '0px 9px'}}>
                                            <input
                                              id="cart-tnc"
                                              name="cart-tnc"
                                              type="checkbox"
                                              ref="cart-tnc"
                                              onClick={() => this.setState({cartConsent: !this.state.cartConsent})}
                                              className='cart-tnc'
                                            />
                                          </div>
                                          <label htmlFor="cart-tnc" style={{fontWeight: 400}}>
                                            I confirm that the declared insured value of each item is correct. 
                                            Any misdeclaration will be subject to <a href="/terms-conditions" style={{fontSize: '13px', fontWeight: 600}} target="_blank">ShippingCart's terms and conditions</a>.                     
                                          </label>
                                        </div>
                                      </div>
                                    }
                                    {this.props.customerCheckout.checkout.data && this.props.customerCheckout.checkout.data.summary.total_price ?
                                      <div style={{borderRadius: '10px', border: '1px solid #E2E2E2', backgroundColor: '#FFF', padding: '20px 16px'}}>
                                        <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px', fontSize: '20px', fontWeight: 600}}>
                                          <span>Shipment Cost</span>
                                          <span>USD {this.props.customerCheckout.checkout.data && this.props.customerCheckout.checkout.data.summary.total_price}</span>
                                        </div>
                                        <input id="submitCart" className='proceedToCheckoutButton' type="submit" onClick={this.handleCheckout} value="Proceed to payment" disabled={!this.props.customerCheckout.fetchItemComputation && (this.state.chkItemArray.sea.length !== 0 || this.state.chkItemArray.air.length !== 0) && this.state.overpriced.length === 0 && !this.props.parcelInfo.parcel_updating && !this.props.customerCheckout.sc_protect_updating && this.state.cartConsent ? "" : "disabled"} />
                                      </div>
                                      
                                       : <input id="submitCart" type="submit" onClick={this.handleCheckout} className={this.state.chkItemArray.sea.length !== 0 || this.state.chkItemArray.air.length !== 0 ? "btn ship-it" : "btn active "} value="Proceed to payment" disabled={!this.props.customerCheckout.fetchItemComputation && (this.state.chkItemArray.sea.length !== 0 || this.state.chkItemArray.air.length !== 0) && this.state.overpriced.length === 0 && !this.props.parcelInfo.parcel_updating && !this.props.customerCheckout.sc_protect_updating && this.state.cartConsent ? "" : "disabled"} />}

                                    <div className="details">
                                      <span>You can still review your orders before payment.</span>
                                      <span> We group your items according to shipping method</span>
                                      <span> (air or sea) and deliver them to your doorstep.</span>
                                    </div>
                                  </div>
                                </div>

                              </header>
                            )
                          }
                        }
                      </Sticky>
                    </div>
                  </div>
                </StickyContainer>

                : null}

            </div>

            : !this.props.parcelInfo.cart_fetching && this.props.parcelInfo.cartData && this.props.parcelInfo.cartData.items.length <= 0 ?

              <div className="storage-wrapper">
                <div className="header">
                </div>

                <div className="partial messages clearfix">
                </div>
                <div className="estimations-wrapper storage-empty">
                  <div className="notify">
                    <div className="notify-header">
                      <h3><span className="icon"></span>Your cart storage is empty.</h3>
                    </div>
                    <div className="notify-content">
                      <h4>Did you ship something to your ShippingCart address?</h4>
                      <p>We'll let you know as soon as we've accepted your package and immediately queue it for processing.<br /> Processing involves weighing, photographing any documentation from your seller that includes list of what's in your package, and encoding into our system before it can be viewed in your cart.</p>
                    </div>
                  </div>
                </div>
              </div>

              : null

          }
        </div>
        {this.state.incompleteInfo ? 
          <RequiredModal show={true}
          first_name={this.props.login.login.party.first_name}
          last_name={this.props.login.login.party.last_name}
          email={this.props.login.login.party.email}
          phone_number={this.props.login.login.party.phone_number}
          error={this.props.login.error && this.props.login.error.data ? this.props.login.error.data.errors : null}
          fb_id={this.props.login.login.party.fb_id}
          />
        : null}
        {localStorage.cartExtensionModalShowed ? null :
          this.props.cms.modalExtensionContent ?
            this.props.cms.getModal && this.props.cms.modalExtensionContent.data.status ?
              <AdvisoryExtensionModal show={this.props.cms.showAdvisoryExtensionModal['cart']}
                close={dispatch => this.props.closeModal('cartExtension')}
                content={this.cartExtensionModal()}
              />
            : null
          : null
        }
        {localStorage.cartModalShowed ? null :
          this.props.cms.modalContent ?
            !disabledCart && this.props.cms.getModal && this.props.cms.modalContent.data.status ?
              <AdvisoryModal show={this.props.cms.showAdvisoryModal['cart']}
                close={dispatch => this.props.closeModal('cart')}
                content={this.cartModal()}
              />
            : null
          : null
        }
        <DamagedModal 
          isOpen={this.state.damagedModalOpen}
          handleClose={() => this.setState({damagedModalOpen : false})}
          damageItems={this.props.customerCheckout.checkout.data && this.props.customerCheckout.checkout.data.damage_items}
        />
      </div>
    )
  },
});

export default Dashboard;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardFiles/Cart.js
 **/